import React from 'react';
import { useApp } from '../context/AppContext';
import './Profile.css';

function formatDate(dateStr) {
  if (!dateStr) return '—';
  return new Date(dateStr).toLocaleDateString('es-AR', {
    day: 'numeric', month: 'long', year: 'numeric',
  });
}

export default function Profile({ onBack }) {
  const { user, logout, sessions, progress, favorites, textSize, setTextSize } = useApp();

  const listenedCount  = sessions.filter(s => (progress[s.id]?.pct || 0) >= 80).length;
  const favoritesCount = Object.values(favorites).filter(Boolean).length;
  const inProgress     = sessions.filter(s => {
    const p = progress[s.id]?.pct || 0;
    return p > 0 && p < 80;
  }).length;

  const daysLeft  = user?.daysLeft ?? 0;
  const isExpired = daysLeft <= 0;

  return (
    <div className="profile-screen">
      <div className="profile-header">
        <button className="profile-back" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M13 4L7 10L13 16" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
        <div className="profile-avatar">
          {user?.name?.charAt(0).toUpperCase() || '?'}
        </div>
        <div className="profile-name">{user?.name}</div>
        <div className="profile-email">{user?.email}</div>
      </div>

      {/* suscripción */}
      <div className="profile-section">
        <div className="profile-section-label">Suscripción</div>
        <div className={`profile-sub-card ${isExpired ? 'expired' : ''}`}>
          <div className="profile-sub-status">
            <span className={`sub-dot ${isExpired ? 'red' : 'green'}`} />
            <span>{isExpired ? 'Vencida' : 'Activa'}</span>
          </div>
          {!isExpired ? (
            <>
              <div className="profile-sub-days">
                <span className="days-number">{daysLeft}</span>
                <span className="days-label">{daysLeft === 1 ? 'día restante' : 'días restantes'}</span>
              </div>
              <div className="profile-sub-until">
                Vence el {formatDate(user?.subscriptionEnd)}
              </div>
            </>
          ) : (
            <div className="profile-sub-until expired-text">
              Venció el {formatDate(user?.subscriptionEnd)}
            </div>
          )}
        </div>
      </div>

      {/* estadísticas */}
      <div className="profile-section">
        <div className="profile-section-label">Mi actividad</div>
        <div className="profile-stats">
          <div className="stat-card">
            <div className="stat-number">{listenedCount}</div>
            <div className="stat-label">Completadas</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{inProgress}</div>
            <div className="stat-label">En progreso</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">{favoritesCount}</div>
            <div className="stat-label">Favoritas</div>
          </div>
        </div>
      </div>

      {/* sesiones en progreso */}
      {inProgress > 0 && (
        <div className="profile-section">
          <div className="profile-section-label">Continuar escuchando</div>
          {sessions
            .filter(s => { const p = progress[s.id]?.pct || 0; return p > 0 && p < 80; })
            .map(s => (
              <div key={s.id} className="profile-progress-item">
                <div className="ppi-info">
                  <div className="ppi-code">{s.code}</div>
                  <div className="ppi-title">{s.title}</div>
                </div>
                <div className="ppi-bar-wrap">
                  <div className="ppi-bar">
                    <div className="ppi-fill" style={{ width: `${progress[s.id]?.pct || 0}%` }} />
                  </div>
                  <span className="ppi-pct">{Math.round(progress[s.id]?.pct || 0)}%</span>
                </div>
              </div>
            ))
          }
        </div>
      )}

      {/* tamaño de texto */}
      <div className="profile-section">
        <div className="profile-section-label">Tamaño del texto</div>
        <div className="text-size-card">
          <div className="text-size-buttons">
            <button
              className={`tsize-btn ${textSize === 'small' ? 'active' : ''}`}
              onClick={() => setTextSize('small')}
            >
              <span className="tsize-letter" style={{ fontSize: '14px' }}>Aa</span>
              <span className="tsize-label">Pequeño</span>
            </button>
            <button
              className={`tsize-btn ${textSize === 'normal' ? 'active' : ''}`}
              onClick={() => setTextSize('normal')}
            >
              <span className="tsize-letter" style={{ fontSize: '17px' }}>Aa</span>
              <span className="tsize-label">Normal</span>
            </button>
            <button
              className={`tsize-btn ${textSize === 'large' ? 'active' : ''}`}
              onClick={() => setTextSize('large')}
            >
              <span className="tsize-letter" style={{ fontSize: '21px' }}>Aa</span>
              <span className="tsize-label">Grande</span>
            </button>
          </div>
        </div>
      </div>

      <button className="profile-logout" onClick={logout}>Cerrar sesión</button>
    </div>
  );
}
